import { readLearningVisit } from "@/lib/public-learning-visit";
import type { SessionPayload } from "@/types/api";
import { request } from "./transport";

export const auth = {
  getSession: () => request<SessionPayload>("/session"),

  refreshSession: () =>
    request<SessionPayload>("/session/refresh", { method: "POST" }),

  login: (pin: string) =>
    request<SessionPayload>("/login", {
      method: "POST",
      body: JSON.stringify({ user: { pin } }),
    }),

  logout: () => request<{ ok: true }>("/logout", { method: "DELETE" }),

  recoverPin: (email: string, turnstileToken?: string) =>
    request<{ ok: true }>("/auth/recover", {
      method: "POST",
      body: JSON.stringify({
        email,
        ...(turnstileToken ? { turnstile_token: turnstileToken } : {}),
      }),
    }),

  signup: (email: string, ref?: string, turnstileToken?: string) =>
    request<{ ok: true }>("/auth/signup", {
      method: "POST",
      headers: { "X-Learning-Visit": readLearningVisit()?.id ?? "" },
      body: JSON.stringify({
        email,
        ...(ref ? { ref } : {}),
        ...(turnstileToken ? { turnstile_token: turnstileToken } : {}),
      }),
    }),
};
